/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  color: ouiStyle.Constants.Colors.greyDarkest,
  listStyleType: ouiStyle.Constants.ListStyleTypeProps.ordered,
  marginLeft: 3,
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const SanityNumberListContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <ol
      css={css}
    >
      {children}
    </ol>
  );
};
